import { useRef, useState, useContext } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
// mocks_
import account from '../../_mock/account';
import authAPI from 'src/service/authAPI';
import AuthContext from 'src/contexts/AuthContext';
// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Accueil',
    icon: 'eva:home-fill',
    linkTo: '/',
  },
  {
    label: 'Profil',
    icon: 'eva:person-fill',
    linkTo: '#',
  },
  {
    label: 'Reglages',
    icon: 'eva:settings-2-fill',
    linkTo: '#',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const { setIsAuthenticated, setCustomerId } = useContext(AuthContext);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    authAPI.logout();
    setIsAuthenticated(false);
    setCustomerId(null);
    navigate('/login');
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={`${process.env.REACT_APP_BASEURL}${process.env.REACT_APP_CUSTOMERLOGO}`} alt="Vieilles Charrues" sx={{ width: 40, height: 40 }} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        {/*<Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
          Les Vieilles Charrues
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                          {process.env.REACT_APP_FESTIVALNAME}@vieillescharrues.fr
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem sx={{ m: 1 }}>
          Vidéo tutoriel
        </MenuItem>*/}
        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Déconnexion
        </MenuItem>
      </MenuPopover>
    </>
  );
}
